import { render } from "./PastReport.vue?vue&type=template&id=7071b82a&scoped=true"
import script from "./PastReport.vue?vue&type=script&lang=js"
export * from "./PastReport.vue?vue&type=script&lang=js"

import "./PastReport.vue?vue&type=style&index=0&id=7071b82a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7071b82a"]])

export default __exports__